export default "__VITE_ASSET__C$txhdVZ__"